import PropTypes from "prop-types";
import React from "react";
import { StyleSheet, View, Animated, ActivityIndicator } from "react-native";
import ENV from "app/utils/ENV";
import Text from "app/components/Text";
import TouchableOpacity from "app/components/TouchableOpacity";
import momentActions from "app/utils/momentActions";
import textHelpers from "app/utils/textHelpers";
import timeHelpers from "app/utils/timeHelpers";
import valueHelpers from "app/utils/valueHelpers";
import colorHelpers from "app/utils/colorHelpers";

import MomentBullet from "app/components/chapter/MomentBullet";
import Icon from "app/components/Icon";

import { StyleContext } from "app/contexts/Style";

export default class Tag extends React.Component {
  static contextType = StyleContext;
  static propTypes = {
    value: PropTypes.object,
    small: PropTypes.bool,
  };

  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      expanded: false,
      momentBullet: false,
    };
  }

  render() {
    let {
      value,
      small,
      includeHash,
      icon,
      onPress,
      maxWidth,
      momentBulletOnPress,
      highlighted,
    } = this.props;
    let { expanded, momentBullet } = this.state;

    let color =
      valueHelpers.colorAsHex(value?.color) || this.context.colors.foreground;
    // let backgroundColor = colorHelpers.hexToRgbaString(color, 0.2);
    let backgroundColor = colorHelpers.hexToRgbaString(color, 0.3);
    // let backgroundColor = colorHelpers.modifyHex(color, 1.5);

    if (["white", "cream", "yellow"].includes(value?.color)) {
      color = this.context.colors.darkForeground;
    }

    if (highlighted || this.props.statusOverride == "completion") {
      backgroundColor = color;
      color = this.context.colors.lightForeground;
    }

    let spacing = small ? this.context.sizes.tiny : this.context.sizes.small;
    let fontSize = small ? this.context.sizes.base : this.context.sizes.default;

    if (momentBullet) {
      return (
        <MomentBullet
          moment={{ value }}
          onEscape={() => this.setState({ momentBullet: false })}
        />
      );
    }

    return (
      <TouchableOpacity
        onLongPress={() => this.setState({ momentBullet: true })}
        onPress={
          !!momentBulletOnPress
            ? () => this.setState({ momentBullet: true })
            : onPress
        }
        onDoublePress={this.props.onDoublePress}
      >
        <View
          style={{
            alignSelf: "flex-start",
            flexDirection: "row",
            alignItems: "center",
            borderRadius: this.context.sizes.smallBorderRadius,
            marginRight: spacing,
            maxWidth: maxWidth || (small ? 100 : 200),
            padding: this.context.sizes.tiny,
            paddingHorizontal: spacing,
            paddingRight:
              small && icon && !!value.icon
                ? this.context.sizes.small
                : spacing,
            backgroundColor: backgroundColor,
          }}
        >
          {!!icon && value.icon && (
            <Icon
              name={value.icon}
              color={color}
              size={fontSize}
              style={{ marginRight: this.context.sizes.small }}
            />
          )}
          <Text
            style={{
              color,
              fontSize,
              // maxWidth: expanded ? 999 : 80
            }}
            numberOfLines={1}
            // ellipsizeMode={small ? "clip" : "tail"} // not working in web?
          >
            {includeHash && "#"}
            {valueHelpers.filterRichText(value.title || value.text, value)}
          </Text>
        </View>
      </TouchableOpacity>
    );
  }
}
